import { useMemo } from 'react'
import { Link, useLocation } from 'react-router'
import { aClient, aSelectedListing, useAtomValue, useSetAtom } from '~/atoms'
import { cn } from '~/lib'

export default function MapNavigationTabs({
  className,
}: {
  className?: string
}) {
  const location = useLocation()
  const client = useAtomValue(aClient)
  const setSelectedListing = useSetAtom(aSelectedListing)

  const currentView = useMemo(() => {
    if (location.pathname.startsWith('/demographics')) {
      return 'Demographics'
    }
    if (location.pathname.startsWith('/cards')) {
      return 'Cards'
    }
    return 'Map'
  }, [location])

  return (
    <div className={cn('rounded-md shadow-md', className)}>
      <div className="inline-flex h-10 items-center justify-center rounded-md bg-background p-1 text-muted-foreground">
        <Link
          id="nav-map"
          to={`/${location.search}`}
          className={cn(
            'inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all',
            currentView === 'Map' && 'bg-primary text-white'
          )}>
          Map
        </Link>
        <Link
          id="nav-cards"
          to={`/cards${location.search}`}
          onClick={() => {
            setSelectedListing(null)
          }}
          className={cn(
            'inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all',
            currentView === 'Cards' && 'bg-primary text-white shadow-sm'
          )}>
          Cards
        </Link>
        {client?.show_demographics === true && (
          <Link
            id="nav-demographics"
            to={`/demographics${location.search}`}
            className={cn(
              'inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all',
              currentView === 'Demographics' && 'bg-primary text-white'
            )}>
            Demographics
          </Link>
        )}
      </div>
    </div>
  )
}
